/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable, Injector} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {AbstractService} from '../../common/service/abstract.service';
import {User} from '../../domain/user/user';
import 'rxjs/add/operator/toPromise';
import {CookieConstant} from '../../common/constant/cookie.constant';
import {CommonUtil} from '../../common/util/common.util';
import keycloak from "../../../xp/xpProvider";
import {Alert} from "../../common/util/alert.util";
import {WorkspaceService} from "../../workspace/service/workspace.service";
import {PermissionService} from "./permission.service";
import {ActivatedRoute} from "@angular/router";

@Injectable()
export class UserService extends AbstractService {

  constructor(protected injector: Injector,
              private workspaceService: WorkspaceService,
              private permissionService: PermissionService) {
    super(injector);
  }

  private URL_USER = this.API_URL + 'users';
  public kc:any;
  public _isLoggedIn(): Promise<boolean> {

    const token = this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN);
    const userId: string = CommonUtil.getLoginUserId();

    // 토큰이 존재하면
    if (token !== '') {

      // this
      const scope: any = this;

      // URL
      const url = this.URL_USER + '/' + userId;

      // 헤더
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN_TYPE)
          + ' ' + this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN),

      });

      // 사용자 정보가 있는지 체크
      return this.http.get(url, {headers})
        .toPromise()
        .then(response => Promise.resolve(true))
        .catch(error => scope.isLoggedInErrorHandler(scope, error));
    } else {
      CommonUtil.moveToStartPage(this.router);
      return Promise.resolve(false);
    }
  }

  public async isLoggedIn(): Promise<boolean> {
    const token = this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN);
    const userId: string = CommonUtil.getLoginUserId();

    // 토큰이 존재하면
    if (token !== '') {

      // this
      const scope: any = this;

      // URL
      const url = this.URL_USER + '/' + userId;

      // 헤더
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN_TYPE)
          + ' ' + this.cookieService.get(CookieConstant.KEY.LOGIN_TOKEN),

      });

      // 사용자 정보가 있는지 체크
      return this.http.get(url, {headers})
        .toPromise()
        .then(response => {
          return Promise.resolve(true)
        })
        .catch(error => scope.isLoggedInErrorHandler(scope, error));
    } else {
      await keycloak
        .init({
          onLoad: 'login-required',
          silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`, enableLogging: true
        })
        .then(async (authed: boolean) => {
          if (authed) {
            const userProfile = await keycloak.loadUserProfile()

            const myHeaders = new Headers();
            myHeaders.append("content-type", "application/json");
            myHeaders.append("x-parse-application-id", "rightcomxp");
            myHeaders.append("x-parse-rest-api-key", "restAPIKey");

            const raw = JSON.stringify({
              "realm": window.location.hostname.split('.')[0],
              "user": userProfile,
              "token": "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJ5bE9tcHQySFh4RnhrV1A1cEZDWHY1al8tcGM4NkdZUFZKRE9qU0xlckw4In0"
            });

            const requestOptions: any = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow"
            };

            await fetch("https://hontogbo.rightcomtech.com/xp-api/rest/functions/rightdataInit", requestOptions)
              .then((response) => response.json())
              .then((result) => {
                ///////////////////////////////////////////////////////////////////////
                if (result && result.result && result.result.access_token) {
                  this.cookieService.set("KCCRED", keycloak.token, 0, '/');
                  this.cookieService.set(CookieConstant.KEY.LOGIN_TOKEN, result.result.access_token, 0, '/');
                  this.cookieService.set(CookieConstant.KEY.LOGIN_TOKEN_TYPE, result.result.token_type, 0, '/');
                  this.cookieService.set(CookieConstant.KEY.REFRESH_LOGIN_TOKEN, result.result.refresh_token, 0, '/');
                  this.cookieService.set(CookieConstant.KEY.LOGIN_USER_ID, userProfile.id, 0, '/');
                  this.cookieService.set(CookieConstant.KEY.SAVE_USER_ID, userProfile.id, 0, '/');
                  this.permissionService.getPermissions('SYSTEM').then((permission) => {
                    if (permission && 0 < permission.length) {
                      this.cookieService.set(CookieConstant.KEY.PERMISSION, permission.join('=='), 0, '/');
                      this.workspaceService.getMyWorkspace().then(wsInfo => {
                        this.cookieService.set(CookieConstant.KEY.MY_WORKSPACE, JSON.stringify(wsInfo), 0, '/');
                        console.log(result.result.last_login_time, result.result.last_login_ip, '/workspace');
                        window.location.reload()
                      }).catch(() => {
                        //this.logout();
                        Alert.error(this.translateService.instant('login.ui.failed'), true);
                      });
                    } else {
                      console.log(result.result.last_login_time, result.result.last_login_ip, '/workspace');
                      window.location.reload()
                    }
                  });

                } else {
                  //this._logout();
                  Alert.error(this.translateService.instant('login.ui.failed'), true);
                }
                ///////////////////////////////////////////////////////////////////////
              })
              .catch((error) => console.error(error));

          } else {
            keycloak.login()
          }
        })
        .catch(console.error)
      // CommonUtil.moveToStartPage( this.router );
      // return Promise.resolve(false);
    }

    // return Promise.resolve(false);
  }

  // 사용자 정보가 없을 경우 리플레시 토큰이 있으면 토큰을 갱신
  // 정상적으로 토큰이 갱신되면 페이지로 진입 토큰이 갱신되지 않으면 로그인 페이지로
  public isLoggedInErrorHandler(): Promise<any> {
    const refreshToken = this.cookieService.get(CookieConstant.KEY.REFRESH_LOGIN_TOKEN);
    const userId: string = CommonUtil.getLoginUserId();
    if (refreshToken != null && userId != null) {
      return this.refreshToken().then((token) => {
        // 쿠키 저장
        this.cookieService.set(CookieConstant.KEY.LOGIN_TOKEN, token.access_token, 0, "/");
        this.cookieService.set(CookieConstant.KEY.LOGIN_TOKEN_TYPE, token.token_type, 0, "/");
        this.cookieService.set(CookieConstant.KEY.REFRESH_LOGIN_TOKEN, token.refresh_token, 0, "/");
        return true;
      }).catch(() => {
        this.router.navigate(['/user/login']);
        return false;
      });
    } else {
      this.router.navigate(['/user/login']);
      return Promise.resolve(false);
    }
  }

  // 로그인
  public login(user: User, basicHeader?: string): Promise<any> {
    return this.getToken(user, basicHeader);
  }

  public logout(): Promise<any> {
    const kc = this.cookieService.get('KCCRED')
    if (kc){
      keycloak.init({token:kc, }).then((res)=>{
        keycloak.logout()
      })
    }
    return this.get(this.API_URL + 'logout');
  }

  public accountManagement(): Promise<any> {
    const kc = this.cookieService.get('KCCRED')
    if (kc){
      keycloak.init({token:kc, }).then((res)=>{
        keycloak.accountManagement()
      })
    }
    return this.get(this.API_URL + 'logout');
  }

  public checkUserIp(user: User, basicHeader?: string): Promise<any> {
    return this.checkIp(user, basicHeader);
  }

  // 유저정보
  public getUser(username: string): Promise<User> {
    return this.get(this.URL_USER + '/' + username);
  }

  // 사용자 신청
  public join(user: User): Promise<any> {
    return this.postWithoutToken(this.API_URL + 'users/signup', user);
  }

  // 아이디 중복 체크
  public duplicateId(username: string): Promise<any> {
    return this.getWithoutToken(this.URL_USER + `/username/${username}/duplicated`);
  }

  // 이메일 중복 체크
  public duplicateEmail(email: string): Promise<any> {
    return this.getWithoutToken(this.URL_USER + `/email/${email}/duplicated`);
  }

  public validatePassword(params: any): Promise<any> {
    return this.postWithoutToken(this.API_URL + 'users/password/validate', params);
  }

  // 비밀번호 reset API
  public resetPassword(email: string): Promise<any> {
    return this.postWithoutToken(this.URL_USER + '/password/reset', {email});
  }

  // 모든 유저리스트 조회
  public getUserList(param: any, projection: string = 'forListView'): Promise<any> {
    let url = this.URL_USER;
    url += '?' + CommonUtil.objectToUrlString(param);
    return this.get(url + `&projection=${projection}`);
  }

  /**
   * 사용자 상세정보 조회
   * @param {string} username
   * @param {string} projection
   * @returns {Promise<any>}
   */
  public getUserDetail(username: string, projection: string = 'forDetailView'): Promise<any> {
    return this.get(this.URL_USER + `/${username}?projection=${projection}`);
  }

  /**
   * 사용자 정보 수정
   * @param {string} username
   * @param params
   * @returns {Promise<any>}
   */
  public updateUser(username: string, params: any): Promise<any> {
    return this.patch(this.URL_USER + `/${username}`, params);
  }

  public updateInitialUser(username: string, params: any): Promise<any> {
    return this.postWithoutToken(this.URL_USER + `/password`, params);
  }

  /**
   * 사용자 비밀번호 체크
   * @param {string} username
   * @param {string} password
   * @returns {Promise<any>}
   */
  public checkUserPassword(username: string, password: string) {
    return this.post(this.URL_USER + `/${username}/check/password`, {password: password});
  }

  public getClientDetail(clientId: string) {
    return this.getWithoutToken(this.API_URL + `oauth/${clientId}`);
  }

}
